import { render, staticRenderFns } from "./EipSwitch.vue?vue&type=template&id=24bcd9c5&scoped=true&"
import script from "./EipSwitch.vue?vue&type=script&lang=js&"
export * from "./EipSwitch.vue?vue&type=script&lang=js&"
import style0 from "./EipSwitch.vue?vue&type=style&index=0&id=24bcd9c5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bcd9c5",
  null
  
)

export default component.exports